<template>
    <div class="d-flex">
        <div class="header me-5">
            <h3>Soubory</h3>
        </div>
        <div>
            <button class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#uploadFile">
                <span>Nahrát soubor</span>
            </button>
            <Popup :header="$t('utils.uploadFile')" :editable="false" :submitable="true" id="uploadFile"
                @save-data="uploadFile">
                <template v-slot:body>
                    <div>
                        <label>{{ $t('orders.title') }}</label>
                        <input type="text" class="form-control" v-model="postData.title">
                    </div>
                    <div class="mt-3">
                        <label>{{ $t('orders.fileType') }}</label>
                        <select class="form-select" v-model="postData.file_type">
                            <option v-for="fileType in fileTypes" :key="fileType" :value="fileType">
                                {{ fileType }}
                            </option>
                        </select>
                    </div>
                    <div class="mt-3">
                        <label>{{ $t('orders.file') }}</label>
                        <input type="file" class="form-control" @change="onFileChanged">
                    </div>
                </template>
            </Popup>
        </div>
    </div>
    <div class="files row mx-3">
        <div v-for="file in files" class="file d-flex flex-column p-3 me-2 col-3 mt-2">
            <div class="d-flex justify-content-between">
                <span v-if="file.name !== 'null'">{{ file.name }}</span>
                <span v-else>{{ $t('utils.notFilled') }}</span>
                <div>
                    <icon icon="FileDownload" style="width: 30px; height: 30px" class="icon"
                        @click="downloadFile(file)" />
                    <icon icon="Delete" style="width: 30px; height: 30px;" class="icon delete_icon"
                        @click="deleteFile(file.id)" />
                </div>
            </div>
            <span v-if="file.file_type !== 'null'">{{ file.file_type }}</span>
            <span v-else>{{ $t('utils.notFilled') }}</span>
            <span>{{ file.uploaded_by.first_name }} {{ file.uploaded_by.last_name }}</span>
            <span>{{ file.created }}</span>
        </div>
    </div>
</template>
<script>
import Popup from "./Popup.vue";
export default {
    components: {
        Popup
    },
    props: {
        files: {
            type: Array,
            required: true
        },
        orderFileContainer: {
            type: Boolean,
            required: false
        },
        customerFileContainer: {
            type: Boolean,
            required: false
        },
        transportFileContainer: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            orderFileTypes: [
                "Dodací list",
                "Faktura",
                "Jiné"
            ],
            customerFileTypes: [
                "Jiné"
            ],
            transportFileTypes: [
                "Dodací list",
                "Jiné"
            ],
            postData: {
                title: null,
                file: null,
                file_type: null
            }
        }
    },
    methods: {
        onFileChanged(event) {
            const file = event.target.files[0];
            this.postData.file = file
        },
        uploadFile() {
            this.$emit('uploadFile', this.postData)
            this.postData = {
                title: null,
                file: null,
                file_type: null
            }
        },
        deleteFile(id) {
            this.$emit('deleteFile', id)
        },
        downloadFile(file) {
            this.$emit('downloadFile', file)
        }
    },
    computed: {
        fileTypes() {
            if (this.orderFileContainer) {
                return this.orderFileTypes;
            } else if (this.customerFileContainer) {
                return this.customerFileTypes;
            } else if (this.transportFileContainer) {
                return this.transportFileTypes;
            }
            return []
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.file {
    border: 2px solid $primary;
    border-radius: 25px;
}

.icon:hover {
    cursor: pointer;
    opacity: 0.7;
}

.delete_icon {
    color: $red;
}
</style>